// ============================================================================
// REPORT CLASS SERVICE (read-only, ADR-0029)
// Financial-statement sections between account type and subtype.
// ============================================================================

import { get } from '../client/axiosClient';
import { reportClassEndpoints } from '../endpoints/accounts.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  BackendPagedResult,
  PaginatedResponse,
  ID,
  ReportClassDto,
  ReportClassQueryParams,
} from '../types';

class ReportClassService {
  async getAll(params?: ReportClassQueryParams): Promise<PaginatedResponse<ReportClassDto>> {
    const endpoint = params
      ? buildEndpointWithQuery(reportClassEndpoints.list(), params)
      : reportClassEndpoints.list();
    const response = await get<ApiResponse<BackendPagedResult<ReportClassDto>>>(endpoint);
    const paged = response.data.data;
    return {
      success: response.data.success,
      message: response.data.message,
      data: Array.from(paged.items || []),
      pagination: {
        currentPage: paged.page,
        pageSize: paged.pageSize,
        totalPages: paged.totalPages,
        totalItems: paged.totalCount,
        hasNextPage: paged.hasNext,
        hasPreviousPage: paged.hasPrevious,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<ReportClassDto>> {
    const response = await get<ApiResponse<ReportClassDto>>(reportClassEndpoints.getById(id));
    return response.data;
  }
}

export const reportClassService = new ReportClassService();
export default reportClassService;
